import { TPayment } from "../types/payment/TPayment"
import { EProviderName } from "../types/provider/IProvider"
import { TSwiipeService } from "../types/services/TSwiipeService"

const serviceInclusionPerCountry: { [countryCode: string]: { whitelist?: TSwiipeService[]; blacklist?: TSwiipeService[] } } = {
    default: {
        whitelist: ["PayFaqDigiteal", "CreditCard", "Checkout", "Winback"],
    },
    BE: {
        whitelist: ["PayFaqDigiteal", "CreditCard", "Checkout", "Bancontact", "Ideal", "TermsTech", "Winback"],
    },
    NL: {
        whitelist: ["PayFaqDigiteal", "CreditCard", "Checkout", "Bancontact", "Ideal", "TermsTech", "Winback"],
    },
    LU: {
        whitelist: ["PayFaqDigiteal", "CreditCard", "Checkout", "Bancontact", "Ideal", "TermsTech", "Winback"],
    },
    DK: {
        blacklist: ["PayFaqDigiteal", "Bancontact", "Ideal", "TermsTech"],
    },
    NO: {
        blacklist: ["PayFaqDigiteal", "Bancontact", "Ideal", "TermsTech"],
    },
    SE: {
        blacklist: ["PayFaqDigiteal", "Bancontact", "Ideal", "TermsTech"],
    },
}

export function isServiceAvailableForMerchantCountry(service: TSwiipeService, countryCode: string) {
    const cc = countryCode.toUpperCase()
    const config = serviceInclusionPerCountry[cc] ?? serviceInclusionPerCountry["default"]
    return config.whitelist ? config.whitelist.includes(service) : config.blacklist ? !config.blacklist.includes(service) : true
}

export function getDefaultProviderForPaymentType(countryCode: string, paymentType: TPayment): EProviderName {
    switch (paymentType) {
        case "AccountToAccount":
            return "AccountToAccount"
        case "Anyday":
            return "Anyday"
        case "ApplePay":
            return "PaymentIQ"
        case "Bancontact":
            return "Digiteal"
        case "Ideal":
            return "Digiteal"
        case "CreditCard":
            return ["NO", "SE", "DK"].includes(countryCode) ? "PaymentIQ" : "Digiteal"
        case "KlarnaFinancing":
            return "PaymentIQ"
        case "KlarnaPayLater":
            return "PaymentIQ"
        case "MobilePayOnline":
            return "PaymentIQ"
        case "ResursInvoice":
            return "Resurs"
        case "ResursPartPayment":
            return "Resurs"
        case "ResursRevolvingCredit":
            return "Resurs"
        case "Swish":
            return "PaymentIQ"
        case "Viabill":
            return "Viabill"
        case "Vipps":
            return "VippsMobilePay"
        case "TermsTech":
            return "Area42"
    }
}
